"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_APPRENTICE_ROSTER_INIT = exports.GET_APPRENTICE_ROSTER = exports.REPLACE_EXTERNAL_VALIDATOR = exports.GET_STUDENT_DETAILS = exports.UPDATE_APPRENTICE_GATEWAY_DETAILS = void 0;
exports.UPDATE_APPRENTICE_GATEWAY_DETAILS = `
  mutation updateApprenticeGatewayDetails($apprenticeGatewayDetails: ApprenticeGatewayDetails) {
    updateApprenticeGatewayDetails(apprenticeGatewayDetails: $apprenticeGatewayDetails)
  }
`;
exports.GET_STUDENT_DETAILS = `
  query getStudentDetails($studentId: String!, $orgId: String!) {
    getStudentDetails(studentId: $studentId, orgId: $orgId)
  }
`;
exports.REPLACE_EXTERNAL_VALIDATOR = `
  mutation replaceExternalValidator($replaceExternalValidatorDetails: ReplaceExternalValidatorDetails) {
    replaceExternalValidator(replaceExternalValidatorDetails: $replaceExternalValidatorDetails)
  }
`;
exports.GET_APPRENTICE_ROSTER = `
  query getApprenticeRosterStudent($rootOrganizationId: String!, $offset: Int!, $limit: Int!, $searchText: String!, $includeAddons: Boolean, $filters: TuitionProviderAdminFilters!) {
    getApprenticeRosterStudent(rootOrganizationId: $rootOrganizationId, offset: $offset, limit: $limit, searchText: $searchText, includeAddons: $includeAddons, filters: $filters) {
      result {
        userId
        rootOrganizationId
        expectedDateOfFirstEpaExam
        expectedGatewayCompletionDate
        apprenticeshipStatus
        cimaStatus
        programStartDate
        actualGatewayCompletionDate
        programEndDate
        isEditLocked
        pathway
        uln
        isAdmin
        title
        firstName
        middleName
        lastName
        dateOfBirth
        gender
        ethnicity
        jobTitle
        membershipType
        membershipTier
        membershipStatus
        email
        externalValidator
        relationshipType
        employerName
      }
      totalCount
    }
  }
`;
exports.GET_APPRENTICE_ROSTER_INIT = `
  query apprenticeRosterInit($orgId: String!) {
    apprenticeRosterInit(orgId: $orgId)
  }
`;
//# sourceMappingURL=tuition-provider-queries.js.map